import React from 'react';
import OceanSelectService from './OceanSelectService';
import CustomerForm from 'components/CustomerForm';
import Ship2Ocean from 'components/Ocean/Ship2Ocean';

const OceanFlow = ({ step, initialValues }) => {

  return (
    <>
      <>{step == 1 && (<OceanSelectService />)}</>
      <>{step == 2 && (<Ship2Ocean />)}</>
      <>{step == 3 && (<CustomerForm initialValues={initialValues} />)}</>
    </>
  );
};

export default OceanFlow;